import PaymentSection from "./PaymentSection";
import YouTubeVerification from "./YouTubeVerification";
import { getPaymentProvider } from "@/lib/payment-provider";
import { cn } from "@/lib/utils";

interface ProductInfoProps {
  title: string;
  price: number;
  discountedPrice?: number;
  isYoutubeSubscriber?: boolean;
  onYoutubeVerificationSuccess?: () => void;
  orderIdPrefix: string;
  productId: string;
  nicepayClientId: string;
  showYoutubeDiscount?: boolean;
  youtubeChannelId?: string;
  youtubeClientId?: string;
}

export default function ProductInfo({
  title,
  price,
  discountedPrice,
  isYoutubeSubscriber,
  onYoutubeVerificationSuccess,
  orderIdPrefix,
  productId,
  nicepayClientId,
  showYoutubeDiscount,
  youtubeChannelId,
  youtubeClientId,
}: ProductInfoProps) {
  return (
    <div className={cn(
      "w-full lg:w-1/3 flex flex-col justify-center space-y-6 mt-6 lg:mt-0 bg-background/80 backdrop-blur-sm",
      // 토스 위젯 자체에 여백이 있으므로 좁은 구매 영역에 중복 패딩을 주지 않는다.
      getPaymentProvider() !== "toss" && "px-5",
    )}>
      {/* 상품 제목 */}
      <div>
        <h1 className="text-2xl font-bold text-foreground mb-2 whitespace-pre-line">
          {title}
        </h1>
      </div>

      {/* 결제 섹션 */}
      <PaymentSection
        price={price}
        discountedPrice={discountedPrice}
        isYoutubeSubscriber={isYoutubeSubscriber || false}
        orderIdPrefix={orderIdPrefix}
        productId={productId}
        nicepayClientId={nicepayClientId}
      />

      {/* YouTube 구독 인증 섹션 */}
      {showYoutubeDiscount && youtubeChannelId && youtubeClientId && discountedPrice && (
        <YouTubeVerification
          channelId={youtubeChannelId}
          clientId={youtubeClientId}
          onVerificationSuccess={onYoutubeVerificationSuccess || (() => {})}
          isVerified={isYoutubeSubscriber || false}
        />
      )}
    </div>
  );
}
